import { ContractorDeactivationReason } from 'src/constants/contractor/enums'
import {
  EarningPaymentMethod,
  FundingInvoiceExternalStatus,
  FundingInvoiceStatus,
  FundingType,
  LoanFundingStatus,
  PaymentStatus,
  SingleFailureReasonType,
} from 'src/constants/payment/enums'

export interface Payment {
  amount: number
  failedAt?: string | null
  failureReason?: null | string
  failureReasonType?: SingleFailureReasonType | null
  id: string
  name: string
  netAmount: string
  paidAt: string
  partnerDriverExternalId: string
  payoutMethod: EarningPaymentMethod
  status: PaymentStatus
  uploadedAt: string
  deactivatedAt?: null | string
  deactivationReason?: null | ContractorDeactivationReason
  destinationLast4?: string | null
  destinationType?: string | null
  paidInGracePeriod?: boolean
  paidTo?: string | null
  isRetryable?: boolean
  isCancelable?: boolean
  isVoidable?: boolean
  onboardingFlow?: string
  isInvoiceGenerated?: boolean
}

export interface FundingMethod {
  type: 'wire' | 'loan'
  available: boolean
}

export interface FundingInvoice {
  id: string
  status: FundingInvoiceStatus
  type: FundingType
  externalStatus?: FundingInvoiceExternalStatus
  loanId?: string
  invoiceIds?: string[]
  loanFundingStatus?: LoanFundingStatus
  loanFundingErrorMessage?: string
  loanDueDate?: string
  loanTotalAmount?: number
  loanBaseFeeAmount?: number
  gigsafeTotalFeeAmount?: number
  dueDate: string
  invoiceDate: string
  paymentDate?: string
  payInvoiceOnDate: string
  amount: number
  description?: string
  invoiceApprovedByPayor: boolean
  payorExternalId: string
  partnerId: string
  earningsCount?: number
}

export interface PaymentsSummary {
  contractorPaymentsCount: number
  contractorFundingAmount: number
  masterContractorPaymentsCount?: number
  masterContractorFundingAmount?: number
}

export enum PartnerPaymentProvider {
  UsBank = 'us_bank',
}

export interface FundingSettingsBankAccountDetails {
  accountName: string
  accountNumber: string
  routingNumber: string
}

export interface FundingSettings {
  methods: FundingMethod[]
  hasRequiredFundingPayments: boolean
  paymentProvider?: PartnerPaymentProvider | null
  bankAccountDetails?: FundingSettingsBankAccountDetails | null
}
